import { useGetLabelByKey } from 'hooks/useLingUI';
import styles from './ProgressBar.module.scss';

export type ProgressBarProps = {
  bgcolor?: string;
  progress: number | null;
  maxLimit: number | null;
  showProgressNumber?: boolean;
  showMaxLimit?: boolean;
  measurementUnit?: string;
  showMeasurementUnit?: boolean;
  currencyType?: string;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  bgcolor,
  progress,
  maxLimit,
  showProgressNumber = true,
  showMaxLimit = true,
  measurementUnit,
  showMeasurementUnit = true,
  currencyType = '€',
}: ProgressBarProps) => {
  const labelNotAvailable = useGetLabelByKey('not-available');
  const backgroundColor = bgcolor ? bgcolor : 'var(--color-accent)';
  const percentProgress = progress && maxLimit ? +((progress * 100) / maxLimit) : 0;
  const formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  });
  return (
    <div className={`${styles.progressBarContainer}`}>
      <div className={`${styles.progressBarBase}`}>
        <div
          className={`${styles.progressBarFiller}`}
          style={{ background: backgroundColor, width: `${percentProgress}%` }}
        ></div>
      </div>
      <div className={`${styles.progressInfo}`}>
        {showProgressNumber && progress !== null && progress !== undefined && (
          <span className={styles.progress}>{currencyType ? `${formatter.format(progress)}` : progress}</span>
        )}
        {showProgressNumber && (progress === null || progress === undefined) && (
          <span className={styles.progress}>{labelNotAvailable}</span>
        )}
        {showMaxLimit && maxLimit && (
          <span className={styles.maxLimit}>{currencyType ? `${formatter.format(maxLimit)}` : maxLimit}</span>
        )}
        {showMaxLimit && !maxLimit && <span className={styles.maxLimit}>{labelNotAvailable}</span>}
        {showMeasurementUnit && measurementUnit && <span className={styles.measurementUnit}>{measurementUnit}</span>}
      </div>
    </div>
  );
};
